import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { Subscription } from 'rxjs';
import { IconModule } from 'src/components/icon/icon.module';
import { ToastService } from 'src/services/toast.service';
import { GlobalService } from 'src/services/global.service';

@Component({
  selector: 'dialog-image-preview',
  templateUrl: './dialog-image-preview.component.html',
  standalone: true,
  imports: [CommonModule, DialogModule, IconModule],
})
export class _DialogImagePreviewComponent implements OnInit, OnDestroy {
  src: string | null = null;
  src$?: Subscription;

  constructor(public globalService: GlobalService) {}

  ngOnInit(): void {
    this.src$ = this.globalService.showImagePreview$.subscribe((src) => {
      this.src = src;
    });
  }

  ngOnDestroy(): void {
    this.src$?.unsubscribe();
  }

  protected get visible(): boolean {
    return !!this.src;
  }

  protected _hide() {
    this.globalService.hideImagePreview();
  }

  protected _onVisibleChange(visible: boolean) {
    if (!visible) this.globalService.hideImagePreview();
  }
}
